import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  /** The h2's id, for the section's aria-labelledby. */
  id?: string;
  align?: 'center' | 'start';
  className?: string;
}

/** Eyebrow, h2 and subtitle at the top of every /storybook section. */
export function SectionHeading({ eyebrow, title, subtitle, id, align = 'center', className }: SectionHeadingProps) {
  return (
    <div className={cn('mb-10 max-w-2xl', align === 'center' ? 'mx-auto text-center' : 'mx-auto text-center lg:mx-0 lg:text-left', className)}>
      <span className="mb-3 inline-block text-sm font-semibold uppercase tracking-wider text-primary">{eyebrow}</span>
      <h2 id={id} className="text-balance text-3xl font-semibold sm:text-4xl">
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-base text-muted-foreground sm:text-lg">{subtitle}</p>}
    </div>
  );
}

/** The "Sample photos" tag: every sample photo on the page sits under one. */
export function SamplePhotosTag({ label, className }: { label: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white px-2.5 py-1 text-[11px] font-bold text-primary shadow-sm ring-1 ring-black/5',
        className,
      )}
    >
      {label}
    </span>
  );
}
